import { Form, Input, Modal } from "antd";
import { useEffect } from "react";
const AddBusinessCategory = ({ isOpen, onOk, onCancel, editMode, itemData, form }) => {

  useEffect(() => {
    if (editMode && itemData) {
      form.setFieldsValue({
        name_en: itemData.locales?.find(loc => loc.languageCode === "en")?.name || "",
        name_ar: itemData.locales?.find(loc => loc.languageCode === "ar")?.name || "",
      });
    } else {
      form.resetFields();
    }
  }, [editMode, itemData, form, isOpen]);

  const handleOk = () => {
    form.validateFields().then(values => {
      onOk(values);
    });
  };

  return (
    <>
      <Modal
        title={editMode ? "Edit Business Category" : "Add Business Category"}
        centered
        open={isOpen}
        onCancel={onCancel}
        onOk={handleOk}
        okText="Save"
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={{
            remember: true,
          }}
          style={{ marginTop: 24 }}
          autoComplete="off"
        >
          <Form.Item
            label="Business Category Name (English)"
            name="name_en"
            rules={[
              {
                required: true,
                message: "Please enter the Business Category Name (English)",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
          <Form.Item
            label="Business Category Name (Arabic)"
            name="name_ar"
            rules={[
              {
                required: true,
                message: "Please enter the Business Category Name (Arabic)",
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
export default AddBusinessCategory;
